import React from 'react';


const AkhuwatLoanInstruction = ()=>{
  return (
    <section className="container-fluid py-5">
      <div className="container">
        <h1 className="text-center mb-4 fw-bold">Keep Track of Your Application, Hassle-Free</h1>
        
        <p className="text-center mb-5">
        
 With Apna Ghar, staying updated on your support request is simple. View all your application details anytime, right at your fingertips.
        </p>
        
        <h2 className="fw-bold mb-4">Here’s How to Check Your Status:</h2>
        
        <ol className="fs-5">
          <li className="mb-2">Go to the official Apna Ghar website.</li>
          <li className="mb-2">Open the “Application Status Checker.”</li>
          <li className="mb-2">Click Check Status to see:</li>
          <ul>
            <li>Your current application stage</li>
            <li>Submitted documents</li>
            <li className="mb-2">Next steps you need to take</li>
          </ul>
          <li className="mb-2">Need a hand? Our friendly support team is always just a message away, ready to guide you.</li>
        </ol>
      </div>
    </section>
  );
}

export default AkhuwatLoanInstruction
